import { useEffect, useState } from "react";
import { getDocs, collection, doc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import styles from "./surveyList.module.css";

const SurveyList = () => {
  const [surveys, setSurveys] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState(null);
  const [newImage, setNewImage] = useState(null);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "surveys"));
        const surveyList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSurveys(surveyList);
      } catch (error) {
        console.error("Помилка при отриманні опитувань:", error);
      }
    };
    fetchSurveys();
  }, []);

  const startEditing = (survey) => {
    setEditingId(survey.id);
    setEditData({ ...survey });
    setNewImage(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleOptionChange = (e, index) => {
    const updatedOptions = [...editData.options];
    updatedOptions[index].text = e.target.value;
    setEditData((prev) => ({ ...prev, options: updatedOptions }));
  };

  const saveChanges = async () => {
    try {
      const docRef = doc(db, "surveys", editingId);

      await updateDoc(docRef, {
        title: editData.title,
        description: editData.description,
        options: editData.options,
      });

      if (newImage) {
        const storage = getStorage();
        const storageRef = ref(storage, `surveyImages/${newImage.name}`);
        await uploadBytes(storageRef, newImage);
        const imageURL = await getDownloadURL(storageRef);
        await updateDoc(docRef, { imageURL });
        editData.imageURL = imageURL;
      }

      setSurveys((prev) =>
        prev.map((s) => (s.id === editingId ? { ...editData } : s))
      );

      Swal.fire("Успішно", "Опитування оновлено", "success");
      setEditingId(null);
    } catch (error) {
      console.error("Помилка при оновленні:", error);
    }
  };

  const resetVotes = async (surveyId) => {
    try {
      const surveyRef = doc(db, "surveys", surveyId);
      const updatedSurvey = surveys.find((s) => s.id === surveyId);
      const resetOptions = updatedSurvey.options.map((opt) => ({
        ...opt,
        score: 0,
      }));

      await updateDoc(surveyRef, { options: resetOptions });

      setSurveys((prev) =>
        prev.map((s) =>
          s.id === surveyId ? { ...s, options: resetOptions } : s
        )
      );

      Swal.fire("Очищено", "Голоси обнулено", "success");
    } catch (error) {
      console.error("Помилка при обнуленні голосів:", error);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Список опитувань</h2>
      {surveys.map((survey) => (
        <div className={styles.card} key={survey.id}>
          {editingId === survey.id ? (
            <div>
              <input
                className={styles.input}
                name="title"
                value={editData.title}
                onChange={handleEditChange}
              />
              <input
                className={styles.input}
                name="description"
                value={editData.description}
                onChange={handleEditChange}
              />
              {editData.options.map((opt, idx) => (
                <div key={idx} className={styles.optionRow}>
                  <input
                    className={styles.input}
                    value={opt.text}
                    onChange={(e) => handleOptionChange(e, idx)}
                  />
                  <span className={styles.score}>Голосів: {opt.score}</span>
                </div>
              ))}
              <input
                type="file"
                className={styles.input}
                onChange={(e) => setNewImage(e.target.files[0])}
              />
              <button
                className={`${styles.button} ${styles.save}`}
                onClick={saveChanges}
              >
                Зберегти
              </button>
            </div>
          ) : (
            <div>
              <h3>{survey.title}</h3>
              <p>{survey.description}</p>
              {survey.imageURL && (
                <img
                  src={survey.imageURL}
                  alt="Survey"
                  className={styles.image}
                />
              )}
              <ul>
                {survey.options.map((opt, idx) => (
                  <li key={idx}>
                    <strong>{opt.text}</strong> — {opt.score} голосів
                  </li>
                ))}
              </ul>
              <div className={styles.buttonGroup}>
                <button
                  className={`${styles.button} ${styles.edit}`}
                  onClick={() => startEditing(survey)}
                >
                  Редагувати
                </button>
                <button
                  className={`${styles.button} ${styles.reset}`}
                  onClick={() => resetVotes(survey.id)}
                >
                  Обнулити голоси
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SurveyList;
